export const FooterData = [
  {
    titleHeader: "Useful Links",
    title: [
     
      {
        Name: "Contact Us",
        href: "contact-us",
      },
      {
        Name: "Sellor Login",
        href: "https://admin.pufframa.com/",
      },
        {
        Name: "Wholesale Enquiry",
        href: "wholesale",
      },
     
    ],
  },
    {
    titleHeader: "Customer Service",
    title: [
     
  
       {
        Name: "Refund and Return Policy",
        href: "refund-policy",
      },
       {
        Name: "Privacy Policies",
        href: "privacy-policy",
      },
       {
        Name: "Return Policy",
        href: "return-policy",
      },
       {
        Name: "Terms and Conditions",
        href: "terms-and-conditions",
      },
      
    ],
  },
  // {
  //   titleHeader: "Top Category",
  //   title: [
  //     {
  //       Name: "Nicotine Shots",
  //       href: "Nicotine-Shots",
  //     },
  //     {
  //       Name: "Kratom",
  //       href: "Kratom",
  //     },
  //     {
  //       Name: "Hardware",
  //       href: "Hardware",
  //     },
  //     {
  //       Name: "E-Liquids",
  //       href: "E-Liquids",
  //     },
  //   ],
  // },
  // {
  //   titleHeader: "My Account",
  //   title: [
  //     {
  //       Name: "Dashboard",
  //       href: "dashboard",
  //     },
  //     {
  //       Name: "My Orders",
  //       href: "my-orders",
  //     },
  //     {
  //       Name: "Recent Orders",
  //       href: "dashboard",
  //     },
  //     {
  //       Name: "Updated Profile",
  //       href: "updated-profile",
  //     },
  //   ],
  // },

];
